import { render, staticRenderFns } from "./ChoiseQuestionDrill.vue?vue&type=template&id=6a60ebed&scoped=true"
import script from "./ChoiseQuestionDrill.vue?vue&type=script&lang=js"
export * from "./ChoiseQuestionDrill.vue?vue&type=script&lang=js"
import style0 from "./ChoiseQuestionDrill.vue?vue&type=style&index=0&id=6a60ebed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a60ebed",
  null
  
)

export default component.exports